import { api } from 'app/app.api';

import {
  CreateRatingSettingsApiArg,
  CreateRatingSettingsResponse,
  DeleteRatingSettingsApiArg,
  DeleteRatingSettingsResponse,
  GetRatingSettingsApiArg,
  GetRatingSettingsResponse,
  LinkRatingSettingsApiArg,
  LinkRatingSettingsResponse,
  ReadRatingSettingsApiArg,
  ReadRatingSettingsLinksApiArg,
  ReadRatingSettingsLinksResponse,
  ReadRatingSettingsResponse,
  ReadSurveyConnectionsApiArg,
  ReadSurveyConnectionsResponse,
  UnlinkRatingSettingsApiArg,
  UnlinkRatingSettingsResponse,
  UpdateRatingSettingsApiArg,
  UpdateRatingSettingsResponse,
} from './types/ratingApi.types';

export const ratingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readRatingSettings: builder.query<
      ReadRatingSettingsResponse,
      ReadRatingSettingsApiArg
    >({
      query: ({ level, surveyType, parentId, language }) => ({
        version: 2,
        path: 'ratings/settings',
        params: { level, surveyType, parentId, language },
        method: 'GET',
      }),
    }),
    getRatingSettings: builder.query<
      GetRatingSettingsResponse,
      GetRatingSettingsApiArg
    >({
      query: ({ ratingSettingsId }) => ({
        version: 2,
        path: `ratings/settings/${ratingSettingsId}`,
        method: 'GET',
      }),
    }),
    deleteRatingSettings: builder.query<
      DeleteRatingSettingsResponse,
      DeleteRatingSettingsApiArg
    >({
      query: ({ ratingSettingsId }) => ({
        version: 2,
        path: `ratings/settings/${ratingSettingsId}`,
        method: 'DELETE',
      }),
    }),
    createRatingSettings: builder.query<
      CreateRatingSettingsResponse,
      CreateRatingSettingsApiArg
    >({
      query: (arg) => ({
        version: 2,
        path: 'ratings/settings',
        method: 'POST',
        body: arg,
      }),
    }),
    //v3, which is not compatible with v2
    linkRatingSettings: builder.query<
      LinkRatingSettingsResponse,
      LinkRatingSettingsApiArg
    >({
      query: (arg) => ({
        version: 3,
        path: `ratings/settings/links`,
        method: 'POST',
        body: {
          ratingSettingsId: arg.rating_settings_id,
          contactPoint: arg.contact_point,
          contactPointKind: arg.contact_point_kind,
          additionalSettings: arg.additional_settings,
        },
      }),
    }),
    unlinkRatingSettings: builder.query<
      UnlinkRatingSettingsResponse,
      UnlinkRatingSettingsApiArg
    >({
      query: (arg) => ({
        version: 3,
        path: `ratings/settings/links`,
        method: 'DELETE',
        body: {
          ratingSettingsId: arg.rating_settings_id,
          contactPoint: arg.contact_point,
          contactPointKind: arg.contact_point_kind,
        },
      }),
    }),
    readRatingSettingsLinks: builder.query<
      ReadRatingSettingsLinksResponse,
      ReadRatingSettingsLinksApiArg
    >({
      query: ({ contactPointKind }) => ({
        version: 3,
        path: 'ratings/settings/links',
        method: 'GET',
        params: {
          contactPointKind,
        },
      }),
    }),
    updateRatingSettings: builder.query<
      UpdateRatingSettingsResponse,
      UpdateRatingSettingsApiArg
    >({
      query: (arg) => ({
        version: 2,
        path: `ratings/settings/${arg.id}`,
        method: 'PUT',
        body: arg,
      }),
    }),
    // Read a list of all connected phone numbers to a Survey
    readSurveyConnections: builder.query<
      ReadSurveyConnectionsResponse,
      ReadSurveyConnectionsApiArg
    >({
      query: ({ ratingSettingId }) => ({
        version: 3,
        path: 'ratings/settings/links',
        params: { ratingSettingId },
        method: 'GET',
      }),
    }),
  }),
});
